import { ORDER_STATUSES } from "@/lib/seedData";

export const FULFILLMENT = {
  pickup:  { key: "pickup",  label: "Pickup",          labelTe: "పికప్",           icon: "📍", badgeClass: "bg-amber-50 text-amber-800 border-amber-200" },
  courier: { key: "courier", label: "Courier Delivery", labelTe: "కొరియర్ డెలివరీ", icon: "🚚", badgeClass: "bg-blue-50 text-blue-800 border-blue-200" },
  store:   { key: "store",   label: "Store Sale",      labelTe: "హోమ్ ఆర్డర్",     icon: "🏠", badgeClass: "bg-[#5A2D1D]/10 text-[#5A2D1D] border-[#5A2D1D]/25" },
};

export const PAYMENT_METHOD_LABELS = { cash: "Cash", upi: "UPI" };

export function normalizeFulfillment(order) {
  if (!order) return "courier";
  if (order.order_source === "store" || order.fulfillment_type === "store") return "store";
  return order.fulfillment_type === "pickup" ? "pickup" : "courier";
}

export function fulfillmentMeta(order, isTe = false) {
  const key = normalizeFulfillment(order);
  const m = FULFILLMENT[key] || FULFILLMENT.courier;
  return { ...m, label: isTe ? m.labelTe : m.label };
}

const PICKUP_LABELS = {
  ready_dispatch: { label: "Ready for Pickup", labelTe: "పికప్‌కు సిద్ధం", desc: "Your order is packed and ready — please collect from us." },
  delivered:      { label: "Collected",        labelTe: "సేకరించారు",       desc: "Order collected successfully." },
};

const COURIER_LABELS = {
  ready_dispatch: { label: "Ready for Dispatch", labelTe: "డిస్‌పాచ్‌కు సిద్ధం", desc: "Your package is ready to be handed over to the courier." },
  dispatched:     { label: "Shipped via Courier", labelTe: "కొరియర్ ద్వారా షిప్", desc: "Shipment has left our facility. Use the tracking link below." },
  delivered:      { label: "Delivered",          labelTe: "డెలివరీ అయింది",      desc: "Order delivered successfully." },
};

export function getTimelineStep(s, fulfillmentKey, isTe = false) {
  if (fulfillmentKey === "pickup" && PICKUP_LABELS[s.key]) {
    const o = PICKUP_LABELS[s.key];
    return { ...s, label: isTe ? o.labelTe : o.label, label_te: o.labelTe, desc: o.desc };
  }
  if (fulfillmentKey === "courier" && COURIER_LABELS[s.key]) {
    const o = COURIER_LABELS[s.key];
    return { ...s, label: isTe ? o.labelTe : o.label, label_te: o.labelTe, desc: o.desc };
  }
  return s;
}

export function getTimelineSteps(order, hasPayment, isTe = false) {
  const fk = normalizeFulfillment(order);
  let steps = ORDER_STATUSES.filter((s) => !s.optional || hasPayment);
  if (fk === "pickup") {
    steps = steps.filter((s) => s.key !== "dispatched");
  }
  return steps.map((s) => getTimelineStep(s, fk, isTe));
}

export function isCourierOrder(order) {
  return normalizeFulfillment(order) === "courier";
}

export function isPickupOrder(order) {
  return normalizeFulfillment(order) === "pickup";
}

export function isStoreOrder(order) {
  return normalizeFulfillment(order) === "store";
}

export function requiresCourierOnDispatch(order) {
  return isCourierOrder(order);
}
